export default __webpack_public_path__ + "static/media/ecom1.26d96e7e.svg";